export default __webpack_public_path__ + "static/dismoi-poster-une-information-ffa0e9ba208beffa41a4fcc9406db9d4.jpg";